// extracted by mini-css-extract-plugin
export var advancedWrap = "ArboretumSearch-module--advancedWrap--2bcac";
export var arboretumSearch = "ArboretumSearch-module--arboretumSearch--ec4fc";
export var contained = "ArboretumSearch-module--contained--0e5f0";
export var container = "ArboretumSearch-module--container--c70bd";
export var content = "ArboretumSearch-module--content--bcfeb";
export var errorMessage = "ArboretumSearch-module--errorMessage--b4c71";
export var formWrap = "ArboretumSearch-module--formWrap--58bc4";
export var mainFormSection = "ArboretumSearch-module--mainFormSection--222e8";
export var searchWrapper = "ArboretumSearch-module--searchWrapper--4d4ef";
export var subhead = "ArboretumSearch-module--subhead--385f5";